import React, {Component} from 'react'
import { Button, Table,  Form, FormGroup, Col, Modal, ModalHeader, ModalFooter, ModalBody, Label } from 'reactstrap';
import {Link} from 'react-router-dom'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import Input from '../Inputs/Input'
import { connect } from 'react-redux'
import { Trans } from "react-i18next";

class StdForm extends Component{

  constructor(props) {
	  super(props);
	  this.state = {disabled: false}
  }
  
  
  render(){	
	  const {handleSubmit, submit, fields, modal, toggle, submitAction, submitting, trans_prefix, change, form, reset, reset_button} = this.props

	  return  (
	    <Modal isOpen={modal} toggle={toggle}>
		    <ModalHeader toggle={toggle}><Trans>{trans_prefix}.form_title</Trans></ModalHeader>
		    
		    <Form onSubmit={handleSubmit(submitAction)}>
		      <ModalBody>
			      {fields.map((f) => 
			        <FormGroup row key={f.name}>
				        
				        <Label for={f.name} sm={4}>
				          {trans_prefix != null ? <Trans>{trans_prefix}.{f.name}</Trans> : f.name}
				        </Label>
				        <Col xs="8">
				          <Input {...f} change={change} form_name={form} />
				        </Col>
			        </FormGroup>
			      )}
		      </ModalBody>
		      <ModalFooter>
			      {reset_button === true ? <Button color="primary" onClick={reset}><Trans>{trans_prefix}.reset</Trans></Button> : ''}
			      <Button color="primary" type="submit" disabled={submitting}><Trans>{trans_prefix}.submit</Trans></Button>
			      <Button color="secondary" onClick={toggle}><Trans>{trans_prefix}.cancel</Trans></Button>
		      </ModalFooter>
		    </Form>
		    
	    </Modal>)

  }
}




export default ({form_name, validation}) => reduxForm({
  form: form_name,
  enableReinitialize: true,
  destroyOnUnmount: false,
  validate: validation
})(StdForm)
